// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

import { Button } from '@nerdwallet/currency';
import { cdnUri } from '@nerdwallet/nw-client-lib/cdn';

import { useSegmentImpressionHook } from '~/client/lib/analytics/segment-impression';
import useSegmentClicked from '~/client/lib/analytics/use-segment-clicked';
import AuthModal from '../../containers/auth-modal';
import CardCta from '../currency/card-cta/card-cta';

import styles from './guide-sign-up-cta.module.less';

const imgUri = cdnUri('img/diy/hac', 'png');

const GuideSignUpCta = ({
  ctaTitle,
  ctaSubtitle,
  driverLocation,
  flowCopy,
  trackingId,
  impressionPayload,
}) => {
  const flowConfig = {
    slides: [
      {
        copy: flowCopy,
        image: imgUri('house-slider-bg-score'),
      },
      true,
      true,
    ],
  };

  const buttonText = 'JOIN NERDWALLET';

  const { eventId: linkViewedId, ref: linkViewedRef } =
    useSegmentImpressionHook({
      eventType: 'link_viewed',
      attributes: {
        entity_name: 'custom_cta',
        link_copy: buttonText,
        section_name: null,
        link_position: null,
        destination_url: 'reg modal',
        destination_content_id: null,
      },
    });

  const { ref: ctaRef } = useSegmentClicked({
    attributes: {
      entity_name: 'custom_cta',
      parent_event_id: linkViewedId,
    },
  });

  return (
    <CardCta title={ctaTitle} subtitle={ctaSubtitle} trackingId={trackingId}>
      <AuthModal
        driverLocation={driverLocation}
        flow="basic"
        flowConfig={flowConfig}
        tracking={trackingId}
        impressionPayload={impressionPayload}
      >
        <div ref={linkViewedRef}>
          <Button className={styles.joinButton} primary ref={ctaRef}>
            {buttonText}
          </Button>
        </div>
      </AuthModal>
    </CardCta>
  );
};

GuideSignUpCta.propTypes = {
  trackingId: PropTypes.string.isRequired,
  ctaTitle: PropTypes.string,
  ctaSubtitle: PropTypes.string,
  flowCopy: PropTypes.string,
  impressionPayload: PropTypes.object,
  driverLocation: PropTypes.string,
};

GuideSignUpCta.defaultProps = {
  ctaTitle: 'Afford the city you want to live in',
  ctaSubtitle:
    'Get free guidance on changes you can make to afford more home, without spending more.',
  flowCopy: 'Get your free home buying guide',
  impressionPayload: {},
};

export default GuideSignUpCta;
